const Random = {
  roll: function(min,max){
    return (min-1) + Math.ceil(Math.random() * (max-min + 1))
  },
  d20: function(){
    return this.roll(1,20);
  },
}

export default Random;